/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ApiKeyResponse } from '../models/api-key-response';
import { CreateApiKeyRequest } from '../models/create-api-key-request';
import { GetApiKeyResponse } from '../models/get-api-key-response';

/**
 * API to consume the SMS service.
 */
@Injectable({ providedIn: 'root' })
export class ApiKeyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listApiKeys()` */
  static readonly ListApiKeysPath = '/api/v1/api-keys';

  /**
   * Get a list of usernames, API keys, and expiry dates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listApiKeys()` instead.
   *
   * This method doesn't expect any request body.
   */
  listApiKeys$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - name
       */
      search?: string;

      /**
       * This adds a filtering for api keys by user name
       */
      userName?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetApiKeyResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ApiKeyService.ListApiKeysPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
      rb.query('userName', params.userName, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetApiKeyResponse>;
        })
      );
  }

  /**
   * Get a list of usernames, API keys, and expiry dates.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listApiKeys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listApiKeys(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - name
       */
      search?: string;

      /**
       * This adds a filtering for api keys by user name
       */
      userName?: string;
    },
    context?: HttpContext
  ): Observable<GetApiKeyResponse> {
    return this.listApiKeys$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetApiKeyResponse>): GetApiKeyResponse => r.body
      )
    );
  }

  /** Path part for operation `createApiKey()` */
  static readonly CreateApiKeyPath = '/api/v1/api-keys';

  /**
   * Create a new username, API key, and expiry date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiKey$Response(
    params: {
      body: CreateApiKeyRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiKeyResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ApiKeyService.CreateApiKeyPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ApiKeyResponse>;
        })
      );
  }

  /**
   * Create a new username, API key, and expiry date.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiKey(
    params: {
      body: CreateApiKeyRequest;
    },
    context?: HttpContext
  ): Observable<ApiKeyResponse> {
    return this.createApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiKeyResponse>): ApiKeyResponse => r.body)
    );
  }
}
